import * as React from 'react';
import { ArticlePageType } from '../../../utils/context/DeliveryContext';

import { useDeliveryContext } from '../../../utils/hooks/useDeliveryContext';
import { Seo } from '../../../utils/seo/Index';
import { FooterOverride } from '../../layout/FooterOverride';
import { Page } from '../../layout/Page';
import { Button } from '../../ui/button/Button';
import { ButtonGroup } from '../../ui/button/ButtonGroup';
import { ButtonGroupColumn } from '../../ui/button/ButtonGroupColumn';
import { Hero, HeroContent } from '../../ui/hero/Index';
import { Heading } from '../../ui/text/Heading';
import { ArticleHighlight } from './ArticleHighlight';
import { ArticleList } from './ArticleList';
import { DeliveryContainer } from './Container';
import { SectionDeliverySteps } from './SectionDeliverySteps';

const Main: React.FC = () => {
  const { main, getArticlePageType, getFirstArticle } = useDeliveryContext();
  const article = getFirstArticle();
  const data = main();

  return (
    <Page>
      <Seo
        title={data?.titleSEO}
        description={data?.descriptionSEO}
        image={data?.image}
        imageTitle={data?.imageTitle}
      />
      <Hero
        imageUrl={data?.image || ''}
        opacity={data?.imageOpacity ? data.imageOpacity : 1}
        className="content-height flex padding-top-50"
        alt="bilde"
      >
        {data?.title || data?.description ? (
          <HeroContent>
            {data?.title ? (
              <Heading tag="h1" center>
                {data?.title}
              </Heading>
            ) : null}
            {data?.description ? (
              <div
                dangerouslySetInnerHTML={{ __html: data.description }}
                style={{ textAlign: 'center' }}
              />
            ) : null}
          </HeroContent>
        ) : null}
      </Hero>

      {data?.showSteps ? <SectionDeliverySteps /> : null}
      {article?.card?.title ? (
        <ArticleHighlight
          title={article?.card?.title}
          text={article?.card?.description}
          image={article?.image}
          imageOverlay={article?.imageOverlay}
          button={{
            label: article?.card?.buttonLabel,
            link: article?.link || ''
          }}
        />
      ) : null}
      <DeliveryContainer>
        <ArticleList />
        {data?.type !== ArticlePageType.DEFAULT ? (
          <ButtonGroup className="center" style={{ marginBottom: '2em' }}>
            <ButtonGroupColumn className="flex-center-mobile">
              <Button
                as="link"
                type="primary"
                colorTheme="gold"
                to={'/leveransebeskrivelse'}
              >
                Hovedside
              </Button>
            </ButtonGroupColumn>
          </ButtonGroup>
        ) : null}
      </DeliveryContainer>
      <FooterOverride />
    </Page>
  );
};

export default Main;
